import { Typography } from "antd";
import React from "react";
import "./title.css";

interface TitleProps {
  title: string;
}

const Title: React.FC<TitleProps> = (props: TitleProps) => {
  return <Typography className="title">{props.title}</Typography>;
};

export default Title;
